export default __webpack_public_path__ + "images/set/icon-hand.png";